import React, { useState, useEffect } from 'react';
import { useParams, Link, useHistory } from 'react-router-dom';
import axios from 'axios';
import './styles.css';

const SubcategoryPage = () => {
  const { categoryId, subcategoryId } = useParams();
  const history = useHistory();
  const [subcategory, setSubcategory] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [sortBy, setSortBy] = useState('newest'); // 'newest' or 'oldest'

  // Categories mapping for display names
  const categoriesMap = {
    'zacece': 'Začeće',
    'trudnoca': 'Trudnoća',
    'porodjaj': 'Porođaj',
    'zivot-sa-bebom': 'Život sa bebom'
  };

  // Static data for Pre trudnoće i planiranje subcategory
  const staticPreTrudnoceData = {
    name: 'Pre trudnoće i planiranje',
    description: '',
    posts: [
      {
        _id: 'pre-trudnoce-1',
        title: 'Planiranje trudnoće: Kompletni vodič za buduće roditelje',
        excerpt: 'Kompletni vodič za planiranje trudnoće - od pregleda kod lekara do zdravog životnog stila. Saznajte sve što trebate znati pre nego što krenete na putovanje roditeljstva.',
        content: `
          Planiranje trudnoće je jedan od najvažnijih koraka koje možete preduzeti za zdravlje vašeg budućeg deteta i vas same. Pravilna priprema može značajno povećati šanse za zdravu trudnoću i rođenje zdravog deteta.

          Pregled kod lekara pre začeća je ključan korak. Pre nego što počnete da pokušavate da zatrudnite, važno je da se konsultujete sa vašim lekarom. Ovaj pregled uključuje pregled medicinske istorije, fizički pregled, laboratorijske analize krvi, pregled vakcinacije i razgovor o trenutnim lekovima.

          Folna kiselina je B vitamin koji je ključan za pravilno formiranje nervnog sistema bebe. Preporučuje se da žene počnu da uzimaju 400 mikrograma folne kiseline dnevno najmanje mesec dana pre planiranog začeća.

          Priprema za trudnoću uključuje i uspostavljanje zdravih navika: uravnoteženu ishranu bogatu vitaminima i mineralima, redovnu fizičku aktivnost, prestanak pušenja, ograničavanje alkohola i upravljanje stresom.

          Razumevanje vašeg menstrualnog ciklusa i praćenje ovulacije može povećati šanse za začeće. Postoji nekoliko načina za praćenje ovulacije: kalendarska metoda, merenje bazalne telesne temperature, testovi za ovulaciju i praćenje cervikalne sluzi.

          Zapamtite: svaka trudnoća je jedinstvena, i ono što funkcioniše za jednu ženu možda neće funkcionisati za drugu. Uvek se konsultujte sa vašim lekarom za personalizovane savete.
        `,
        createdAt: new Date().toISOString(),
        featuredImage: null
      }
    ]
  };

  useEffect(() => {
    // Special case: redirect to specific post for zacece/pre-trudnoce
    if (categoryId === 'zacece' && subcategoryId === 'pre-trudnoce') {
      history.replace('/post/6836eea7fa77e26e1e702e5a');
      return;
    }

    // Special case: redirect to specific post for trudnoca/prvi-trimestar
    if (categoryId === 'trudnoca' && subcategoryId === 'prvi-trimestar') {
      history.replace('/post/683711ce48879b30ea23a035');
      return;
    }

    // Special case: redirect to specific post for porodjaj/priprema-za-porodjaj
    if (categoryId === 'porodjaj' && subcategoryId === 'priprema-za-porodjaj') {
      history.replace('/post/683713af48879b30ea23a0b2');
      return;
    }

    // Special case: redirect to specific post for zivot-sa-bebom/prvo-putovanje
    if (categoryId === 'zivot-sa-bebom' && subcategoryId === 'prvo-putovanje') {
      history.replace('/post/6837153448879b30ea23a12d');
      return;
    }

    const fetchSubcategory = async () => {
      setLoading(true);
      setError(null);
      
      // Check if this is the pre-trudnoce subcategory and use static data
      if (categoryId === 'zacece' && subcategoryId === 'pre-trudnoce') {
        setSubcategory(staticPreTrudnoceData);
        setLoading(false);
        return;
      }
      
      try {
        const apiUrl = process.env.REACT_APP_API_URL || 'https://jakakaomajka.com/backend';
        const response = await axios.get(
          `${apiUrl}/api/categories/${categoryId}/${subcategoryId}`
        );
        let subcategoryData = response.data;
        
        // Special case: remove title and description for zacece/saveti
        if (categoryId === 'zacece' && subcategoryId === 'saveti') {
          subcategoryData = {
            ...subcategoryData,
            name: '',
            description: ''
          };
        }
        
        // Special case: remove title and description for trudnoca/drugi-trimestar
        if (categoryId === 'trudnoca' && subcategoryId === 'drugi-trimestar') {
          subcategoryData = {
            ...subcategoryData,
            name: '',
            description: ''
          };
        }
        
        // Special case: remove title and description for trudnoca/prva-kupovina
        if (categoryId === 'trudnoca' && subcategoryId === 'prva-kupovina') {
          subcategoryData = {
            ...subcategoryData,
            name: '',
            description: ''
          };
        }
        
        // Special case: remove title and description for trudnoca/treci-trimestar
        if (categoryId === 'trudnoca' && subcategoryId === 'treci-trimestar') {
          subcategoryData = {
            ...subcategoryData,
            name: '',
            description: ''
          };
        }
        
        // Special case: remove title and description for porodjaj/priprema-za-postpartum
        if (categoryId === 'porodjaj' && subcategoryId === 'priprema-za-postpartum') {
          subcategoryData = {
            ...subcategoryData,
            name: '',
            description: ''
          };
        }
        
        // Special case: remove title and description for porodjaj/dojenje
        if (categoryId === 'porodjaj' && subcategoryId === 'dojenje') {
          subcategoryData = {
            ...subcategoryData,
            name: '',
            description: ''
          };
        }
        
        // Special case: remove title and description for zivot-sa-bebom/nemlecna-ishrana
        if (categoryId === 'zivot-sa-bebom' && subcategoryId === 'nemlecna-ishrana') {
          subcategoryData = {
            ...subcategoryData,
            name: '',
            description: ''
          };
        }
        
        // Special case: remove title and description for zivot-sa-bebom/dijagnoze-fizijatra
        if (categoryId === 'zivot-sa-bebom' && subcategoryId === 'dijagnoze-fizijatra') {
          subcategoryData = {
            ...subcategoryData,
            name: '',
            description: ''
          };
        }
        
        // Special case: remove title and description for zivot-sa-bebom/prva-temperatura-korona
        if (categoryId === 'zivot-sa-bebom' && subcategoryId === 'prva-temperatura-korona') {
          subcategoryData = {
            ...subcategoryData,
            name: '',
            description: ''
          };
        }
        
        // Special case: remove title and description for zivot-sa-bebom/produzenje-porodiljskog
        if (categoryId === 'zivot-sa-bebom' && subcategoryId === 'produzenje-porodiljskog') {
          subcategoryData = {
            ...subcategoryData,
            name: '',
            description: ''
          };
        }
        
        // Special case: remove title and description for zivot-sa-bebom/prvi-rodjendan-krstenje
        if (categoryId === 'zivot-sa-bebom' && subcategoryId === 'prvi-rodjendan-krstenje') {
          subcategoryData = {
            ...subcategoryData,
            name: '',
            description: ''
          };
        }
        
        // Special case: remove title and description for zivot-sa-bebom/hodanje
        if (categoryId === 'zivot-sa-bebom' && subcategoryId === 'hodanje') {
          subcategoryData = {
            ...subcategoryData,
            name: '',
            description: ''
          };
        }
        
        // Special case: remove title and description for zivot-sa-bebom/psihoza
        if (categoryId === 'zivot-sa-bebom' && subcategoryId === 'psihoza') {
          subcategoryData = {
            ...subcategoryData,
            name: '',
            description: ''
          };
        }
        
        // Special case: remove title and description for zivot-sa-bebom/vrtic-adaptacija
        if (categoryId === 'zivot-sa-bebom' && subcategoryId === 'vrtic-adaptacija') {
          subcategoryData = {
            ...subcategoryData,
            name: '',
            description: ''
          };
        }
        
        setSubcategory(subcategoryData);
      } catch (err) {
        // If backend is not available and this is pre-trudnoce, use static data
        if (categoryId === 'zacece' && subcategoryId === 'pre-trudnoce') {
          setSubcategory(staticPreTrudnoceData);
        } else {
          setError(err.response?.data?.message || 'Greška pri učitavanju podkategorije');
        }
      } finally {
        setLoading(false);
      }
    };

    fetchSubcategory();
  }, [categoryId, subcategoryId, history]);

  // Function to calculate reading time
  const calculateReadingTime = (content) => {
    const wordsPerMinute = 200;
    const words = content.split(' ').length;
    const minutes = Math.ceil(words / wordsPerMinute);
    return `${minutes} min čitanja`;
  };

  // Function to format date
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('sr-RS', {
      day: 'numeric',
      month: 'long',
      year: 'numeric'
    });
  };

  const sortPosts = (posts) => {
    if (!posts || !Array.isArray(posts)) return [];
    return [...posts].sort((a, b) => {
      const dateA = new Date(a.createdAt);
      const dateB = new Date(b.createdAt);
      return sortBy === 'newest' ? dateB - dateA : dateA - dateB;
    });
  };

  if (loading) {
    return (
      <div className="subcategory-page">
        <div className="loading-spinner">
          <div>Učitavanje...</div>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="subcategory-page">
        <div className="error-message">
          <h2>Došlo je do greške</h2>
          <p>{error}</p>
          <button onClick={() => window.location.reload()} className="retry-button">
            Pokušaj ponovo
          </button>
        </div>
      </div>
    );
  }

  if (!subcategory) {
    return (
      <div className="subcategory-page">
        <div className="not-found-message">
          <h2>Podkategorija nije pronađena</h2>
          <Link to="/categories" className="back-link">
            Nazad na kategorije
          </Link>
        </div>
      </div>
    );
  }

  const sortedPosts = sortPosts(subcategory.posts);

  return (
    <div className="subcategory-page">
      <div className="subcategory-header">
        <h1>{subcategory.name}</h1>
        <p>{subcategory.description}</p>
      </div>

      <div className="posts-grid">
        {sortedPosts.length > 0 ? (
          sortedPosts.map((post) => (
            <Link to={`/post/${post._id}`} key={post._id} className="post-card-link">
              <div className="post-card">
                {post.featuredImage && (
                  <div className="post-image">
                    <img
                      src={`${process.env.REACT_APP_API_URL || 'https://jakakaomajka.com/backend'}/${post.featuredImage.startsWith('/') ? post.featuredImage.slice(1) : post.featuredImage}`}
                      alt={post.title}
                      className="post-img"
                      loading="lazy"
                    />
                  </div>
                )}
                <div className="post-content">
                  <div className="post-tag">
                    {categoriesMap[categoryId] || categoryId}
                  </div>
                  
                  <h3>{post.title}</h3>
                  
                  <p className="post-excerpt">
                    {post.excerpt || post.content.substring(0, 150)}...
                  </p>
                  
                  <div className="post-meta">
                    <div className="post-date">
                      <svg className="calendar-icon" width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M8 2V6M16 2V6M3 10H21M5 4H19C20.1046 4 21 4.89543 21 6V20C21 21.1046 20.1046 22 19 22H5C3.89543 22 3 21.1046 3 20V6C3 4.89543 3.89543 4 5 4Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                      </svg>
                      {formatDate(post.createdAt)}
                    </div>
                    
                    <div className="reading-time">
                      <svg className="clock-icon" width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="2"/>
                        <polyline points="12,6 12,12 16,14" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                      </svg>
                      {calculateReadingTime(post.content)}
                    </div>
                  </div>
                </div>
              </div>
            </Link>
          ))
        ) : (
          <div className="no-posts-message">
            <p>Novi tekst će biti objavljen uskoro.</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default SubcategoryPage; 